import React from 'react'

const ThierMessage = ({lastMessage, message}) => {
 // console.log(message.text)
const isFirstMessageByUser = !lastMessage || lastMessage.sender.username !== message.sender.username;
// The above will return a boolean value tht lets us know if the message is the first message of the user
const checker = message.attachments.length;
// console.log(checker)


 return (
  <div className="message-row">
   {
    isFirstMessageByUser && (
     <div 
     className="message-avatar"
     style={{
      backgroundImage:`url(${message.sender.avatar})`
     }}
     />
    )
   }
     

     {  message.attachments.length > 0 
      
    ? (
 <img src={message.attachments[0].file}
    alt="message-attachment"
    className="message-image"
    style={{ marginLeft: isFirstMessageByUser ? '4px' : '48px' }}

   />
) : (
        <div className="message" style={{
         float: 'left',
        
         background: '#CABCDC',
         marginLeft: isFirstMessageByUser ? '4px' : '48px'
        }}>
         {message.text}
        </div>
)
   
        }
      
  </div>
 );
}

export default ThierMessage
